import React from "react";
import style from "./pma.module.css";
import { MinusOutlined, PlusOutlined } from "@ant-design/icons";
function RadiusBtn({
  fixedRadiusInMiles,
  handleRadiusMiles,
  radiusPerMile,
  color,
}) {
  const maxMiles = radiusPerMile[radiusPerMile.length - 1];
  return (
    <div className={style.btn_wrapper} id="btn_wrapper_report">
      <button
        style={color && { backgroundColor: color }}
        disabled={fixedRadiusInMiles === 1 ? true : false}
        onClick={() => handleRadiusMiles(-1)}
      >
        <MinusOutlined />
      </button>
      <span className={style.permiles}>{fixedRadiusInMiles} Miles</span>
      <button
        style={color && { backgroundColor: color }}
        disabled={fixedRadiusInMiles === maxMiles ? true : false}
        onClick={() => handleRadiusMiles(1)}
      >
        <PlusOutlined />
      </button>
    </div>
  );
}

export default RadiusBtn;
